import { f7 } from 'framework7-react';
import { FC } from 'react';
import style from './servicePromotionCardStyle.module.css';
import { paths } from '@/config/paths';
import IconCategoryCar from '@/assets/images/menu/icon-category-car.svg';
import IconCategoryMaintenance from '@/assets/images/menu/icon-category-maintenance.svg';
import IconCategoryShop from '@/assets/images/menu/icon-category-shop.svg';
import IconCategoryRentCar from '@/assets/images/menu/icon-category-rent-car.svg';

export const ServicePromotionCard: FC = () => {
  const handleClickButton = () => {
    f7.views.main.router.navigate(paths.servicesAll);
  };

  return (
    <div className={style['card-wrapper']}>
      <div className={style['text-content']}>
        <div className={style['title']}>売却からメンテナンス、レンタルまで</div>
        <div className={style['subtitle']}>
          あなたの
          <span className={style['highlight']}>
            カーライフをまとめてサポート
          </span>
        </div>
      </div>

      <div className={style['icon-row']}>
        <div className={style['icon-item']}>
          <img src={IconCategoryCar} alt="売却・購入" className={style['icon-img']} />
        </div>
        <div className={style['icon-item']}>
          <img src={IconCategoryMaintenance} alt="メンテナンス" className={style['icon-img']} />
        </div>
        <div className={style['icon-item']}>
          <img src={IconCategoryShop} alt="買う" className={style['icon-img']} />
        </div>
        <div className={style['icon-item']}>
          <img src={IconCategoryRentCar} alt="借りる" className={style['icon-img']} />
        </div>
      </div>

      <button className={style['cta-button']} onClick={handleClickButton}>
        サービスを詳しく見る
        <i className="icon-right" />
      </button>
    </div>
  );
};
